import React, { Fragment, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Card,
  CardBody,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { Spinner } from "../../AbstractElements";

const ResetNewPassword = () => {
  const location = useLocation();
  const { userId } = location.state || {};
  console.log("🚀 ~ ResetNewPassword ~ userId:", userId)

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);
  const [toggleConfirmPassword, setToggleConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const params = new URLSearchParams(location.search);
  const email = params.get("email"); 
  const Data = [
    {
      id: 2,
      heading: "Loader 3",
      spinnerClass: "loader-3",
    },
  ];
  const handleResetPassword = (e) => {
    e.preventDefault();
    setLoader(true);

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    // Implement your password reset logic here
    // Example:
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/reset-password`, { email, password: password, newPassword: password })
      .then(response => {
        if (response.status === 200) {
          toast.success(response.data.message);

          setLoader(false);
          navigate('/');
        }
      })
      .catch(error => {
        alert("Error resetting password");
      });
    navigate("/");
  };

  return (
    <Fragment>
      <ToastContainer position="top-right" />
      <Container fluid>
        <Row
          className="justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <Col xs="12" sm="8" md="6" lg="4">
            <Card className="card p-3">
              <CardBody>
                <Link
                  to="/forgot-password"
                  className="btn btn-link position-absolute"
                  style={{
                    font: "12px",
                    top: "10px",
                    left: "10px",
                    color: "black",
                    fontWeight: "bold",
                    textDecoration: "none",
                  }}
                >
                  &larr; Back to Forgot Password
                </Link>
                <Form className="theme-form login-form">
                  <FormGroup className="position-relative">
                    <Label style={{ color: "grey", margin: "20px 0px 60px" }}>
                      Create a new password that is safer and easier to
                      remember.
                    </Label>
                    <div className="position-relative">
                      <Input
                        className="form-control"
                        type={togglePassword ? "text" : "password"}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        placeholder="Password"
                      />
                      <FontAwesomeIcon
                        icon={togglePassword ? faEyeSlash : faEye}
                        onClick={() => setTogglePassword(!togglePassword)}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "grey",
                        }}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="position-relative">
                    <Input
                      className="form-control"
                      type={toggleConfirmPassword ? "text" : "password"}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      placeholder="Confirm Password"
                    />
                    <FontAwesomeIcon
                      icon={toggleConfirmPassword ? faEyeSlash : faEye}
                      onClick={() =>
                        setToggleConfirmPassword(!toggleConfirmPassword)
                      }
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "grey",
                      }}
                    />
                  </FormGroup>
                  {loader && (
                    <div className="loader-box">
                      <Spinner
                        attrSpinner={{ className: Data[0].spinnerClass }}
                      />
                    </div>
                  )}
                  <button
                    className="btn btn-custom w-100 mt-5"
                    onClick={handleResetPassword}
                    style={{
                      backgroundColor: "#000",
                      borderRadius: "18px",
                      border: "none",
                      color: "#fff",
                      padding: "10px 20px",
                      marginTop: "40px  !important", // Adjust marginTop here to move the button down
                    }}
                  >
                    Continue
                  </button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ResetNewPassword;
